import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Card, DatePicker } from "antd";
import { getColumnsDataComplex } from "./variables/columnsData";
import CommonTable from "components/common/CommonTable";
import Request from "helpers/request";
import { urls } from "helpers/urls";



const processData = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }
  return data.flatMap((session, sessionIndex) =>
    session.messages.map((message, messageIndex) => ({
      key: `${sessionIndex}-${messageIndex}`,
      session_id: session.session_id,
      question: message.user_query,
      answer: message.assistant_response.replace(/<\/?p>/g, ""),
      rating: message.rating,
      site_id: session.site_id,
      site_name: session.site_name,
      ip_address: session.ip_address,
      created_at: message.created_at,
    }))
  );
};

const CustomDatePickerInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
  <button 
    className="w-full rounded-md border bg-white py-1.5 px-3 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" 
    onClick={onClick} 
    ref={ref}
  >
    {value || placeholder}
  </button>
));

const Tables = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [logdata, setLogdata] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [siteNames, setSiteNames] = useState([]);
  const [loading, setLoading] = useState(false);

  const getlogs = () => {
    setLoading(true);
    try {
      Request.get(urls.getlogs)
        .then((response) => {
          const processed = processData(response?.data?.data);
          setLogdata(processed);
          setFilteredData(processed);
          const uniqueSiteNames = [...new Set(processed.map(item => item.site_name))];
          setSiteNames(uniqueSiteNames);
          setLoading(false);
        })
        .catch((error) => {
          console.log("error", error);
          setLogdata([]);
          setFilteredData([]);
          setSiteNames([]);
          setLoading(false);
        });
    } catch (error) {
      console.log("error", error);
      setLogdata([]);
      setFilteredData([]);
      setSiteNames([]);
      setLoading(false);
    }
  };

  const handleFilter = () => {
    if (startDate && endDate) {
      const filtered = logdata.filter(item => {
        const itemDate = new Date(item.created_at);
        const endOfDay = new Date(endDate);
        endOfDay.setHours(23, 59, 59, 999);
        return itemDate >= startDate && itemDate <= endOfDay;
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(logdata);
    }
  };
    


useEffect(() => {
    getlogs();
  }, []);

  return (
    <Card>
    <div>

      <div className="flex justify-between items-center gap-4 chatbot-card-section">
        <div className="text-[30px] font-bold font-figtree chatbot-text" style={{ fontFamily: "figtree" }}>
          <h1>Logs</h1>
        </div>
        <div className="flex items-center gap-4">
          <DatePicker
            placeholder="Start Date"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            customInput={<CustomDatePickerInput placeholder="Start Date" />}
            calendarClassName="calendar_custom"
          />
          <DatePicker
            placeholder="End Date"
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            customInput={<CustomDatePickerInput placeholder="End Date" />}
            calendarClassName="calendar_custom"
          />
          <Button
            className="rounded-md bg-[#2369d2] py-2 px-4 text-sm font-medium text-white"
            style={{ fontFamily: "figtree" }}
            onClick={handleFilter}
          >
            Fetch Data
          </Button>
        </div>
      </div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1 logs-table-wrap">
        <CommonTable
          columns={getColumnsDataComplex(siteNames)}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          loading={loading}
          style={{ fontFamily: "figtree" }}
        />
      </div>
    </div>
    </Card>
  );
};

export default Tables;
